<div class="mt-8">
  <h2 class="text-foreground text-xl font-bold mb-4">BMI Assessment History</h2>

  <div class="flex flex-col gap-4">
    <div
      *ngFor="let item of history"
      class="bg-card rounded-2xl p-4 border border-gray-100 dark:border-foreground-tertiary shadow-sm flex items-center gap-4 cursor-pointer hover:shadow-md transition-shadow"
      (click)="openDetails(item)"
    >
      <!-- Avatar Icon -->
      <div
        class="w-12 h-12 rounded-full bg-[#E8F4FD] flex items-center justify-center flex-shrink-0 text-[#3B9EDA]"
      >
        <i
          class="pi pi-stop bg-blue-500 rounded-md p-1.5 text-white"
          style="font-size: 1.1rem; padding: 2px 6px"
        >
          <div class="w-3 h-0.5 bg-white rounded-full mx-auto mt-0.5"></div>
        </i>
      </div>

      <!-- Summary Content -->
      <div class="flex-1 min-w-0">
        <div class="flex items-center gap-2 flex-wrap">
          <span class="text-[17px] font-bold text-foreground pr-2 font-numeric">
            {{ item.value | number: '1.1-1' }}
          </span>

          <div
            *ngIf="item.progress_from_last_bmi !== 0"
            class="flex items-center gap-1 text-[12px] font-semibold"
            [ngClass]="item.is_positive ? 'text-[#10B981]' : 'text-[#EF4444]'"
          >
            <!-- <svg
              *ngIf="item.is_positive"
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="13"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <polyline points="19 12 12 19 5 12"></polyline>
            </svg> -->

            <!-- UP arrow for is_positive = true (GREEN inherited from parent) -->
            <svg
              *ngIf="item.is_positive"
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="13"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="12" y1="19" x2="12" y2="5"></line>
              <polyline points="5 12 12 5 19 12"></polyline>
            </svg>

            <!-- DOWN arrow for is_positive = false (RED inherited from parent) -->
            <svg
              *ngIf="!item.is_positive"
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="13"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <polyline points="19 12 12 19 5 12"></polyline>
            </svg>

            <span
              >{{ item.is_positive ? '+' : '-'
              }}{{ item.progress_from_last_bmi | number: '1.1-1' }}</span
            >
          </div>

          <span *ngIf="item.progress_from_last_bmi !== 0" class="text-[12px] text-muted-color"
            >BMI vs last assessment</span
          >

          <!-- Status Badge (shown occasionally like mockup) -->
          <span
            *ngIf="item.value >= 25 || item.value < 18.5 || item.progress_from_last_bmi === 0"
            class="px-2.5 py-0.5 rounded-full text-[10px] font-bold ml-1 border"
            [ngClass]="getLabelClass(item.value)"
          >
            {{ getLabelText(item.value) }}
          </span>
        </div>
        <p class="text-[12px] text-muted-color mt-1.5 flex items-center gap-2">
          <i class="pi pi-tags" style="font-size: 0.8rem"></i>
          Weight: {{ item.weight | number: '1.0-0' }}kg
          <span class="w-1 h-1 bg-gray-300 rounded-full mx-1"></span>
          {{ item.date }}
        </p>
      </div>

      <i class="pi pi-chevron-right text-gray-400"></i>
    </div>
  </div>
</div>

<!-- Modal Dialog -->
<p-dialog
  [(visible)]="displayModal"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [showHeader]="true"
  [dismissableMask]="true"
  header="BMI Assessment Details"
  styleClass="rounded-3xl overflow-hidden max-w-[440px] w-[95vw] shadow-xl dark:border-foreground-tertiary m-0 "
>
  <div *ngIf="selectedBmi" class="p-2 relative rounded-[28px]">
    <!-- Main Score Header -->
    <div class="flex items-center justify-between mb-2">
      <div class="text-[28px] font-bold text-foreground leading-none tracking-tight">
        {{ selectedBmi.value | number: '1.1-1' }} <span class="text-[20px] ml-0.5">BMI</span>
      </div>
      <span
        class="px-3 py-1 rounded-md text-[11px] font-bold tracking-wide border"
        [ngClass]="getLabelClass(selectedBmi.value)"
      >
        {{ getLabelText(selectedBmi.value) }}
      </span>
    </div>

    <!-- Dynamic Progress Status -->
    <div
      class="flex items-center gap-1.5 text-[14px] font-bold mb-1"
      [ngClass]="
        selectedBmi.progress_from_last_bmi === 0
          ? 'text-gray-500'
          : selectedBmi.is_positive
            ? 'text-emerald-600'
            : 'text-[#EF4444]'
      "
    >
      <svg
        *ngIf="selectedBmi.progress_from_last_bmi !== 0 && selectedBmi.is_positive"
         xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="13"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="12" y1="19" x2="12" y2="5"></line>
              <polyline points="5 12 12 5 19 12"></polyline>
      </svg>
      <svg
        *ngIf="selectedBmi.progress_from_last_bmi !== 0 && !selectedBmi.is_positive"
         xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="13"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <polyline points="19 12 12 19 5 12"></polyline>
      </svg>

      <span *ngIf="selectedBmi.progress_from_last_bmi !== 0"
        >{{ selectedBmi.is_positive ? '+' : '-'
        }}{{ selectedBmi.progress_from_last_bmi | number: '1.1-1' }} BMI</span
      >
      <span *ngIf="selectedBmi.progress_from_last_bmi === 0">0.0 BMI</span>
      <span class="text-foreground font-normal ml-0.5">vs last assessment</span>
    </div>

    <p class="text-[12px] text-muted-color mb-5">Assessment recorded on {{ selectedBmi.date }}</p>

    <hr class="border-t-[2px] border-dashed border-gray-100 mb-6 dark:border-gray-800" />

    <!-- Detail Rows -->
    <div class="space-y-4 mb-8">
      <!-- Weight Row -->
      <div class="flex items-center justify-between text-[14px]">
        <div class="flex items-center gap-3 text-muted-color">
          <div
            class="w-6 h-6 rounded bg-gray-50 flex items-center justify-center text-gray-500 border border-gray-100"
          >
            <i class="pi pi-stop" style="font-size: 0.7rem"></i>
          </div>
          Current Weight
        </div>
        <span class="font-bold text-foreground">{{ selectedBmi.weight | number: '1.0-1' }}kg</span>
      </div>

      <!-- Height Row -->
      <div class="flex items-center justify-between text-[14px]">
        <div class="flex items-center gap-3 text-muted-color">
          <div class="w-6 h-6 flex items-center justify-center text-gray-500">
            <i class="pi pi-arrows-v"></i>
          </div>
          Height
        </div>
        <span class="font-bold text-foreground">{{ selectedBmi.height | number: '1.0-1' }} cm</span>
      </div>

      <!-- BMI Change Row -->
      <div class="flex items-center justify-between text-[14px]">
        <div class="flex items-center gap-3 text-muted-color">
          <div class="w-6 h-6 flex items-center justify-center text-gray-500">
            <i class="pi pi-chart-line"></i>
          </div>
          BMI Change
        </div>

        <div
          class="flex items-center gap-1 font-bold"
          [ngClass]="selectedBmi.is_positive ? 'text-[#EF4444]' : 'text-[#10B981]'"
        >
          <svg
            *ngIf="selectedBmi.progress_from_last_bmi !== 0 && !selectedBmi.is_positive"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="12" y1="19" x2="12" y2="5"></line>
            <polyline points="5 12 12 5 19 12"></polyline>
          </svg>
          <svg
            *ngIf="selectedBmi.progress_from_last_bmi !== 0 && selectedBmi.is_positive"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <polyline points="19 12 12 19 5 12"></polyline>
          </svg>

          {{ selectedBmi.is_positive ? '+' : '-'
          }}{{ selectedBmi.progress_from_last_bmi | number: '1.1-1' }}
          <span class="text-foreground text-[12px] font-semibold">vs last assessment</span>
        </div>
      </div>
    </div>

    <!-- Info Alert Box -->
    <div class="bg-[#F0F5FF] border border-[#dbeafe] rounded-xl p-4 flex gap-3 mb-6">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        class="text-blue-500 mt-0.5 flex-shrink-0"
        stroke="#F5A623"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <circle cx="12" cy="12" r="5"></circle>
        <line x1="12" y1="1" x2="12" y2="3"></line>
        <line x1="12" y1="21" x2="12" y2="23"></line>
        <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
        <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
        <line x1="1" y1="12" x2="3" y2="12"></line>
        <line x1="21" y1="12" x2="23" y2="12"></line>
        <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
        <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
      </svg>
      <p class="text-[13px] text-gray-700 leading-relaxed font-medium">
        Your BMI is calculated using the height and weight provided during your health assessment.
      </p>
    </div>

    <!-- Call to action -->
    <button
      (click)="displayModal = false"
      class="w-full bg-[#F5A623] hover:bg-[#e69819] transition-colors text-white font-bold text-[16px] py-3.5 rounded-full flex items-center justify-center"
    >
      Got It, Close
    </button>
  </div>
</p-dialog>
